import { Injectable } from '@angular/core';
import { ReportHistory } from '@dpr/models';
import { PersistenceService } from '@shared/services/persistence';
import { Observable } from 'rxjs';

@Injectable()
export class DprReportService {
  constructor(private persistenceService: PersistenceService) {}

  getDprReportHistory(dprId: number | string): Observable<ReportHistory> {
    return this.persistenceService.getDprReportHistory(dprId);
  }
}
